module.exports = __webpack_public_path__ + "img/harmony_02.28e9a258.jpg";